import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SubRowContent from './RowContent';
import SectionTitle from '../../components/SectionTitle';

import {
  Box,
  Typography,
  InputAdornment,
  FormHelperText,
  Stack,
} from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const BabyStatus = (props: Props) => {
  const { disabled, register, getValues, setValue, watch } = props;

  const contents = [
    {
      label: '性别',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.BABY_STATUS.GENDER"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.gender')}
          onChange={v => setValue('newborn_condition.gender', v)}
          width="100px"
        />
      ),
    },
    {
      label: '体重',
      element: (
        <Form.MuiTextField
          placeholder="體重"
          InputProps={{
            endAdornment: <InputAdornment position="end">kg</InputAdornment>,
          }}
          required={false}
          disabled={disabled}
          {...register('newborn_condition.weight')}
        />
      ),
    },
    {
      label: '氧气摄入',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.oxygen_intake')}
          onChange={v => setValue('newborn_condition.oxygen_intake', v)}
          width="100px"
        />
      ),
    },
    {
      label: '第一次排尿',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.first_urine')}
          onChange={v => setValue('newborn_condition.first_urine', v)}
          width="100px"
        />
      ),
    },
    {
      label: '胎粪清除',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.placenta_discharge')}
          onChange={v => setValue('newborn_condition.placenta_discharge', v)}
          width="100px"
        />
      ),
    },
    {
      label: '胎粪颜色',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.fetal_staining')}
          onChange={v => setValue('newborn_condition.fetal_staining', v)}
          width="100px"
        />
      ),
    },
    {
      label: '脐带绕颈',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.nuchal_cord')}
          onChange={v => {
            setValue('newborn_condition.nuchal_cord', v);
            if (v == 1) setValue('newborn_condition.nuchal_cord_content', '');
          }}
          width="100px"
        />
      ),
    },
    {
      label: '复苏',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.resuscitation')}
          onChange={v => {
            setValue('newborn_condition.resuscitation', v);
            if (v == 1) setValue('newborn_condition.resuscitation_content', '');
          }}
          width="100px"
        />
      ),
    },
    {
      label: '外观畸形与规格',
      element: (
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register('newborn_condition.specifications')}
        />
      ),
    },
  ];
  return (
    <>
      <SectionTitle title="新生儿状况" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (label === 'Oxygen \nintake') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={1.2}
                  childrenRatio={1.8}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === 'Meconium \nRemoval') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={1.2}
                  childrenRatio={1.8}
                >
                  {element}
                </SubRowContent>
              </>
            );
          }
          return (
            <>
              <RowContent
                title={label}
                titleRatio={label === '外观畸形与规格' ? 2.8 : 1.2}
                childrenRatio={label === '外观畸形与规格' ? 9.2 : 1.8}
              >
                {element}
              </RowContent>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default BabyStatus;
